<template>
  <div class="plan-query-toggle" :class="{ 'is-dark': isDark }">
    <span class="scope-caption">查询范围</span>
    <div class="scope-options" role="group" aria-label="计划查询范围">
      <a-button class="scope-option" :class="{ 'is-selected': !checked }" :aria-pressed="!checked"
                title="仅查询自己创建或执行的计划" @click="changeScope(false)">我的计划</a-button>
      <a-button class="scope-option" :class="{ 'is-selected': checked }" :aria-pressed="checked"
                title="查询全部计划" @click="changeScope(true)">全部计划</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkPlanQueryToggle',
  props: {
    checked: { type: Boolean, default: false }
  },
  computed: {
    isDark() {
      return !!this.$store && !this.$store.state.bgLight
    }
  },
  methods: {
    changeScope(checked) {
      if (checked !== this.checked) this.$emit('change', checked)
    }
  }
}
</script>

<style scoped>
.plan-query-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  vertical-align: middle;
}
.scope-caption {
  color: #5e6d82;
  font-size: 12px;
  white-space: nowrap;
}
.scope-options {
  display: inline-flex;
  padding: 2px;
  border: 1px solid #d6e4f0;
  border-radius: 18px;
  background: #f0f4f8;
}
.plan-query-toggle .scope-option.ant-btn {
  height: 26px;
  margin: 0;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  color: #5e6d82;
  font-size: 12px;
  line-height: 24px;
  box-shadow: none;
}
.plan-query-toggle .scope-option.ant-btn:hover {
  color: #0958d9;
}
.plan-query-toggle .scope-option.ant-btn.is-selected {
  border-color: #91caff;
  background: #e6f4ff;
  color: #0958d9;
  font-weight: 500;
}
.plan-query-toggle .scope-option.ant-btn:focus-visible {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
}
.is-dark .scope-caption,
.plan-query-toggle.is-dark .scope-option.ant-btn {
  color: #a3b5c7;
}
.is-dark .scope-options {
  border-color: #30465e;
  background: #102033;
}
.plan-query-toggle.is-dark .scope-option.ant-btn:hover {
  color: #ffffff;
}
.plan-query-toggle.is-dark .scope-option.ant-btn.is-selected {
  border-color: #4678a7;
  background: #28527e;
  color: #ffffff;
}
</style>
